import Section from "@/components/Section";
import TroubleshootingCard from "@/components/Troubleshooting/TroubleshootingCard";
import { troubleshootingData } from "@/utils/staticData/dataConstants";
import { Box, Grid, Typography, useTheme } from "@mui/material";

const SolutionsSection = () => {
  const theme = useTheme();
  return (
    <Section pt={{ xs: 5, md: 12.5 }} pb={{ xs: 3.5, md: 7.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Box
          sx={{
            maxWidth: "759px",
            marginBottom: { xs: "40px", md: "80px" }
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: { xs: "16px", md: "24px" },
              textAlign: { xs: "start", md: "center" }
            }}
          >
            Common Issues and Solutions
          </Typography>
          <Typography 
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              textAlign: { xs: "start", md: "center" }
            }}
          >
            Explore our list of frequent issues to find solutions and get your Trackmate device back on track.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {troubleshootingData.map((data, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <TroubleshootingCard
                title={data.title}
                description={data.description}
                iconUrl={data.iconUrl}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Section>
  );
};

export default SolutionsSection;